import { render, staticRenderFns } from "./Employees-table.vue?vue&type=template&id=b8a9e312&"
import script from "./Employees-table.vue?vue&type=script&lang=js&"
export * from "./Employees-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports